module.exports = __webpack_public_path__ + "media/site/images/logo-ed1830e110580042f67fddccd9530b3f.png";